import type { StreamProvider } from '@shared/types/room';

import ProvidersFactory from '../providersFactory';
import type { StreamingProvider } from '../types';

export default class StreamingController {
    provider: StreamingProvider | null;
    factory: ProvidersFactory;

    constructor() {
        this.provider = null;
        this.factory = new ProvidersFactory();
    }

    setProvider(type: StreamProvider) {
        if (this.provider) {
            this.destroyProvider();
        }

        this.provider = this.factory.create(type);
    }

    destroyProvider() {
        this.provider?.destroy();
        this.provider = null;
    }
}